export default __webpack_public_path__ + "media/assets/fonts/081_font_iom-069aa706adccfd21dbcb27a79d854715.woff2";